import type { FaireProductEntity } from "../../entity_types/product";

export const p_bvo07cua: FaireProductEntity = {
  token: "p_bvo07cua",
  type: "product",
  name: "Thank You Leaves Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/59f3ef96f0ed57f0300493994d6487a9464506d4db6bb52a5b46a63649ee6e34/1528385733.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1a0e3649d32c88ba47d2111b7671974d0d10559c12d4a7b349b9c57d460a34ce/1528385734.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:57.807Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
